import { compLayouts, editorCompLayouts } from './compLayoutsCompNode'
import { layoutVariants } from './layoutVariantsCompNode'
import { pinnedLayer } from './pinnedLayerCompNode'
import type { ResponsiveLayoutCssFeature } from './responsiveLayout.types'
import { responsiveLayout } from './responsiveLayoutCompNode'
import { stickyTopOffset } from './stickyTopOffsetCompNode'
import { responsiveLayoutDomApplier } from './responsiveLayoutDomApplier'
import { isPinned } from './isPinnedCompNode'
import { CssFeatureSymbol } from '../../ioc/catharsis-ioc'
import type { BindFeature } from '@wix/thunderbolt-catharsis-ioc'
import { compInfoNodes } from '@wix/thunderbolt-component-isolation'
import { compLayoutFlags } from './compLayoutFlagsCompNode'

export const responsiveLayoutCssFeature: ResponsiveLayoutCssFeature = {
	featureName: 'responsiveLayout',
	experimentName: 'OPEN_TO_ALL',
	renderableNodes: {
		responsiveLayout: responsiveLayout(false),
		pinnedLayer,
		layoutVariants,
		stickyTopOffset,
		isPinned,
	},
	intermediateNodes: {
		compLayouts,
		hasResponsiveLayout: compInfoNodes.hasResponsiveLayout,
		compLayoutFlags,
		classicLayout: compInfoNodes.classicLayout,
	},
	dataMaps: ['layout_data', 'variants_data'],
	domApplier: responsiveLayoutDomApplier,
}

export const editorResponsiveLayoutCssFeature: ResponsiveLayoutCssFeature = {
	...responsiveLayoutCssFeature,
	renderableNodes: {
		...responsiveLayoutCssFeature.renderableNodes,
		responsiveLayout: responsiveLayout(true),
	},
	intermediateNodes: {
		compLayouts: editorCompLayouts,
		hasResponsiveLayout: compInfoNodes.hasResponsiveLayout,
		compLayoutFlags,
		classicLayout: compInfoNodes.classicLayout,
	},
}

export const page: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(responsiveLayoutCssFeature)
}

export const editor: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(editorResponsiveLayoutCssFeature)
}
